import { Component, Input, OnInit } from '@angular/core';
import { ISolicitudEquipoModel } from 'src/app/models/interfaces/solicitud/ISolicitudEquipoModel';

@Component({
  selector: 'app-equipo-form',
  templateUrl: './equipo-form.component.html',
  styleUrls: ['./equipo-form.component.css']
})
export class EquipoFormComponent implements OnInit {
  @Input() equipo!: ISolicitudEquipoModel;
  @Input() disabled: boolean = false;
  
  constructor() { }

  ngOnInit(): void {
  }

}
